import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContentEvents from '../components/events/ContentEvents';

function Events() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <ContentEvents />
      </main>
      <Footer />
    </div>
  );
}

export default Events;
